export default __webpack_public_path__ + "static/media/photo--lg--leena-2.30ba5b3e.jpg";